import {
  AdminConfigPermissions,
  AttachmentUploadPermissions,
  AttachmentViewPermissions,
  ConnectPermission,
  FlightRoomPermissions,
  GeneralPermissions,
  LockedFlightPermissions,
  MentionPermissions,
  PermissionType,
  RolesPermissions,
} from '@connect-x-app/shared-domain-models';

const mapPermissionsToObjects = (
  input:
    | typeof AdminConfigPermissions
    | typeof FlightRoomPermissions
    | typeof GeneralPermissions
    | typeof RolesPermissions
    | typeof LockedFlightPermissions
    | typeof MentionPermissions
    | typeof AttachmentUploadPermissions
    | typeof AttachmentViewPermissions,
) =>
  Object.entries(input).map(([label, permission]: [string, ConnectPermission]) => ({
    action: label.toUpperCase(),
    permission,
  }));

export type PermissionGroupsType = {
  key: string;
  permissionType: PermissionType;
  permissions: {
    action: string;
    permission: ConnectPermission;
  }[];
};

const PermissionGroups: PermissionGroupsType[] = [
  {
    key: 'FLIGHT_ROOMS',
    permissions: mapPermissionsToObjects(FlightRoomPermissions),
    permissionType: PermissionType.FLIGHTROOM,
  },
  {
    key: 'MENTIONS',
    permissions: mapPermissionsToObjects(MentionPermissions),
    permissionType: PermissionType.FLIGHTROOM,
  },
  {
    key: 'ATTACHMENT_UPLOADS',
    permissions: mapPermissionsToObjects(AttachmentUploadPermissions),
    permissionType: PermissionType.FLIGHTROOM,
  },
  {
    key: 'ATTACHMENT_VIEW',
    permissions: mapPermissionsToObjects(AttachmentViewPermissions),
    permissionType: PermissionType.FLIGHTROOM,
  },
  {
    key: 'LOCKED_FLIGHTS',
    permissions: mapPermissionsToObjects(LockedFlightPermissions),
    permissionType: PermissionType.FLIGHTROOM,
  },
  {
    key: 'GENERAL',
    permissions: mapPermissionsToObjects(AdminConfigPermissions),
    permissionType: PermissionType.ADMIN,
  },
  {
    key: 'ROLES',
    permissions: mapPermissionsToObjects(RolesPermissions),
    permissionType: PermissionType.ADMIN,
  },
];

export const getGroupedPermissionByType = (permissionType: PermissionType) => {
  return PermissionGroups.filter(p => p.permissionType === permissionType);
};

export const getFlattenedPermissions = (permissionGroups: PermissionGroupsType[]) => {
  return permissionGroups.map(({ permissions }) => permissions.map(({ permission }) => permission)).flat();
};

export const getAllPermissionsByType = (permissionType: PermissionType) => {
  return getFlattenedPermissions(getGroupedPermissionByType(permissionType));
};

export const AllPermissions = getFlattenedPermissions(PermissionGroups);

export default PermissionGroups;
